module.exports = __webpack_public_path__ + "img/Vector.3bf961d8.png";